import script from "./edit-note-modal.vue?vue&type=script&setup=true&lang=ts"
export * from "./edit-note-modal.vue?vue&type=script&setup=true&lang=ts"

import "./edit-note-modal.vue?vue&type=style&index=0&id=7c213738&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c213738"]])

export default __exports__